module.exports = __webpack_public_path__ + "static/media/media-shake-main.24d0bd50.png";